import { AxiosGet, AxiosPost } from "../AxiosWrapper";
import { MANAGEMENT_SERVICE_URL } from "../../constants/ServiceUrls";

export const getAnnouncementsForDisplay = (
  getAnnouncementsForDisplayParameters
) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/Announcement/GetAnnouncementsForDisplay`,
    getAnnouncementsForDisplayParameters
  );
};

export const getAnnouncements = () => {
  return AxiosGet(`${MANAGEMENT_SERVICE_URL}api/Announcement/GetAnnouncements`);
};

export const upsertAnnouncement = (upsertAnnouncementParameters) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/Announcement/UpsertAnnouncement`,
    upsertAnnouncementParameters
  );
};

export const deleteAnnouncement = (deleteAnnouncementParameters) => {
  return AxiosPost(
    `${MANAGEMENT_SERVICE_URL}api/Announcement/DeleteAnnouncement`,
    deleteAnnouncementParameters
  );
};

export default {
  getAnnouncementsForDisplay,
  getAnnouncements,
  upsertAnnouncement,
  deleteAnnouncement,
};
